import { render, staticRenderFns } from "./PayForm.vue?vue&type=template&id=248c7fa1&scoped=true&"
import script from "./PayForm.vue?vue&type=script&lang=js&"
export * from "./PayForm.vue?vue&type=script&lang=js&"
import style0 from "./PayForm.vue?vue&type=style&index=0&id=248c7fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c7fa1",
  null
  
)

export default component.exports